import { Intent } from 'v3/quantConfig/types/intent.type';
import { Pipe } from 'v3/quantConfig/types/pipe.type';
import { IntentPointer, OperandPointer } from 'v3/quantConfig/types/pointer';
import { Case, SignalIntent } from 'v3/quantConfig/types/quantConfig.type';
import { Operand } from 'v3/quantConfig/types/signal.type';

export enum REFERENCE_LIST {
  case = 'case',
  pipe = 'pipe',
  intent = 'intent',
  adjustment = 'adjustment',
}

export type CaseEntity = {
  type: REFERENCE_LIST.case;
  index: number;
  details: Case;
};

export type IntentEntity = {
  type: REFERENCE_LIST.intent;
  index: number | string;
  details: Intent;
};

export type PipeEntity = {
  type: REFERENCE_LIST.pipe;
  index: number;
  details: Pipe;
};

export type AdjustmentEntity = {
  type: REFERENCE_LIST.adjustment;
  index: number;
  details: SignalIntent;
};

export type BaseReference = {
  pointer: IntentPointer | OperandPointer;
  operand?: Operand;
};

export type DeleteReferenceModalProps = {
  onClose: () => void;
  entity: ReferenceEntity;
  references: BaseReference[];
};

export type ReferenceEntity = CaseEntity | IntentEntity | PipeEntity | AdjustmentEntity;
